export var MarginsMixin = function MarginsMixin(chart, props) {
  //HACK: Find long-term way of setting default margins other than here
  var _props$margins = props.margins,
      margins = _props$margins === void 0 ? [10, 50, 30, 30] : _props$margins; // Default margins object

  var marginObj = {};

  if (Array.isArray(margins)) {
    // Make copy of array to prevent reference
    var mcopy = margins.slice(0);
    marginObj['top'] = 0 + mcopy[0];
    marginObj['right'] = 0 + mcopy[1];
    marginObj['bottom'] = 0 + mcopy[2];
    marginObj['left'] = 0 + mcopy[3];
  } else if (typeof margins === 'object') {
    // Assign object to blank to prevent reference
    marginObj = Object.assign(marginObj, margins);
  }

  if (marginObj.hasOwnProperty('top')) {
    chart.margins(marginObj);
  }

  return chart;
};